module.exports = {
	"pagination": {
		"DescribeInstanceHealth": {
			"result_key": "InstanceStates"
		},
		"DescribeLoadBalancerPolicies": {
			"result_key": "PolicyDescriptions"
		},
		"DescribeLoadBalancerPolicyTypes": {
			"result_key": "PolicyTypeDescriptions"
		},
		"DescribeLoadBalancers": {
			"input_token": "Marker",
			"output_token": "NextMarker",
			"result_key": "LoadBalancerDescriptions"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/elasticloadbalancing-2012-06-01.paginators.json
// module id = 640
// module chunks = 0